import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=d3477aa0&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3477aa0')) {
      api.createRecord('d3477aa0', component.options)
    } else {
      api.reload('d3477aa0', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=d3477aa0&", function () {
      api.rerender('d3477aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AnmJhTc5nBgO/JS/comp/FavElement.vue"
export default component.exports